import axios from "axios"
import { brandRequestConfig } from '@/modules/Brand/requestBrand'

const baseObj = {
  baseURL: `${process.env.VUE_APP_SERVER_URL}/public/`,
  withCredentials: false,
  headers: {
    "x-clientid": process.env.VUE_APP_SERVER_API_KEY,
  },
}

export default {
  /**
   * Make an api call to the server. Token in local storage is required
   */
  Api() {
    return axios.create(baseObj)
  },
  /**
   * Check if server is available
   */
  ping() {
    this.Api().get("")
      .then(response => response.status === 200)
  },
  States() {
    return this.Api().get("pos/state")
      .then(response => response.data)
  },
  Country() {
    return this.Api().get("pos/country")
      .then(response => response.data)
  },
  PaymentProcessors() {
    return this.Api().get("pos/paymentProcessors")
      .then(response => response.data)
  },
  MasterCategories() {
    return this.Api().get("pos/category")
      .then(response => response.data)
  },
  GetPlans(params, currentBrand) {
    return this.Api().get("billing/plans", { params, ...brandRequestConfig(currentBrand) })
      .then(response => response.data)
  },
}
